import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import whoWe from '../images/who-we.jpg';
import icon from '../images/icon.png';
import bosco from '../images/ivan-bosco.jpg';

const Urjad = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <div className="bg-grey">
          <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414]">Виконавчий уряд провінції</h1>
        </div>
        <div className="text-justify hyphens-auto" id="section4">
          <div className="pt-2 pb-2">
            Провінційний настоятель: отець Михайло Чабан, СДБ
          </div>
          <div className="pt-2 pb-2">
            Провінційний вікарій: отець Андрій Боднар, СДБ
          </div>
          <div className="pt-2 pb-2">
            Провінційний економ: отець Іван Мазуркевич, СДБ
          </div>
          <div className="pt-2 pb-2">
            Провінційний секретарь та радник: отець Андрій Платош, СДБ
          </div>
          <div className="pt-2 pb-2">
            Провінційний радник: отець Григорій Швед, СДБ
          </div>
          <div className="pt-2 pb-2">
            Провінційний радник: отець Тарас Байовський, СДБ
          </div>
        </div>
      </div>
    </>
  );
};

export default Urjad;
